import { getUser as getLocalUser } from 'Service/localUser'
import { getUserParamsForIntercom as getUserParams } from 'Utils'

export const mapStateToProps = ({ user: { profileFetched, updated: userUpdated } }) => ({
  userUpdated,
  profileFetched,
})

export const handlers = () => ({})

export const childHandlers = () => ({
  updateUserProfile:
    ({ updateIntercom }) =>
    () => {
      const params = getUserParams()
      updateIntercom(params)
    },
  updateUser:
    ({ updateIntercom }) =>
    () => {
      // TODO: decide the params which can be here
      const { userId: user_id, email } = getLocalUser()
      if (user_id) {
        updateIntercom({
          email,
          user_id,
        })
      }
    },
})

export const onComponentDidUpdate = (prevProps, props) => {
  const { userUpdated, profileFetched } = props
  if (userUpdated !== prevProps.userUpdated && userUpdated) {
    props.updateUser()
  }
  if (profileFetched !== prevProps.profileFetched && profileFetched) {
    props.updateUserProfile()
  }
}
